import ToastElement from '../../../../Components/UiComponents/ToastElement';
import Loader from '../../../../Components/UiComponents/Loader';
import { useState, useEffect, useRef } from "react";
import { useForm, Controller } from 'react-hook-form';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { Dialog } from "primereact/dialog";
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import CreateNewStakeHolder from '../../Stakeholders/CreateNewStakeHolder';
import DropdownElement from '../../../../Components/UiComponents/DropdownElement';
import { filter as fil } from '../../../../Services/clientService';
import DataTable from "../../../../Components/UiComponents/DataTable";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { getOrgTeam } from '../../../../Services/organisationService';
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import InputTextElement from '../../../../Components/UiComponents/InputTextElement';
import CreateNewContacts from '../../Stakeholders/ClientEdit/Address&Contact/createNewContacts';
import _ from 'lodash';
import React from 'react'
import { getAdvisorsAndOrgs } from '../../../../Services/advisorService';
import { Tooltip } from 'primereact/tooltip';
import { addExistingAdvisor, updateExistingMember, downloadDocs, generateAdvisor } from '../../../../Services/opportunityService';
import { addNewMember } from '../../../../Services/organisationService';
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const Stakeholders = ((props) => {
	const { formState: { errors }, setValue, getValues, control } = useForm();
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const [loading, setLoading] = useState(false);
	const toastRef = useRef();
	const [isModelOpen, setModelOpen] = useState(false);
	const [isTeamModelOpen, setTeamModelOpen] = useState(false);
	const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
	const [selectedOption, setSelectedOption] = useState('');
	const [stakeVisible, setStakeVisible] = useState(false);
	const [teamVisible, setTeamVisible] = useState(false);
	const [stakeHolderDetails, setStakeHolderDetails] = useState([]);
	const [selectedRow, setSelectedRow] = useState();
	const [selectedTeamRow, setSelectedTeamRow] = useState();
	const [currentIndex, setCurrentIndex] = useState(0);
	const [newModule, setNewModule] = useState([]);
	const [orgId, setOrganisationId] = useState();
	const [advIndex, setAdvIndex] = useState();
	const [orgTeam, setOrgTeam] = useState([]);
	const [opportunityData, setOpportunityData] = useState();
	const [selectedAdvOption, setSelectedAdvOption] = useState([]);
	const [editData, setEditData] = useState({});
	const [selectedTeamMem, setSelectedTeamMem] = useState([]);
	const [selectedOptionNeeds,setSelectedOptionNeeds] = useState([])
	const [selectedOptionObjectives,setSelectedOptionObjectives] = useState([])
	const [selectedOptionValues,setSelectedOptionValues] = useState([])
	const [showVideo, setShowVideo] = useState(false);
	
	const handleButtonClick = () => {
        setShowVideo(true);
      };
    
      const closeVideo = () => {
          setShowVideo(false);
      };

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props.opportunityData)
			getTeamMember(props.opportunityData)
			getEditData(props.opportunityData);
		}
		getStatkeHolderDetails()
	}, [props.opportunityData])

	useEffect(() => {
		if (props.opportunityData) {
			getTeamMember(props.opportunityData)
		}
	}, [currentIndex])

	useEffect(() => {
		let opportunityDataCopy = opportunityData
		if (opportunityDataCopy) {
			opportunityDataCopy["win_score"] = globalOpportunityData.win_score
		}
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			...opportunityDataCopy,
		}));
	}, [opportunityData]);
	useEffect(() => {
		setOpportunityData((prevData) => ({
			...prevData,
			["win_score"]: globalOpportunityData.win_score
		}))
	}, [])

	useEffect(() => {
		if (props.stakeholderData?.pipelineStakeSections) {
			let obj1 = _.find(props.stakeholderData?.pipelineStakeSections, { section_name: "Individual Stakeholder Involved" })?.display_name;
			let obj2 = _.find(props.stakeholderData?.pipelineStakeSections, { section_name: "Stakeholder Information" })?.display_name;
			let obj3 = _.find(props.stakeholderData?.pipelineStakeSections, { section_name: "Stakeholder Insight" })?.display_name;

			let combined = { obj1, obj2, obj3 };
			setNewModule(combined)
		}
	}, [props.stakeholderData?.pipelineStakeSections])

	useEffect(() => {
		if (currentIndex > 0) {
			var selectedTeamMem = []
			if (opportunityData.advisor[currentIndex].advisor_team.length >= 1) {
				for (var i = 0; i < opportunityData.advisor[currentIndex].advisor_team.length; i++) {
					orgTeam.forEach(function (value) {
						if (value._id === opportunityData.advisor[currentIndex].advisor_team[i].organisation_team_id) {
							opportunityData.advisor[currentIndex].advisor_team[i].organisation_team = value.full_name;
							selectedTeamMem.push(value);
						}
					});
				}
				setSelectedTeamMem(selectedTeamMem)
			}
			getEditData(props.opportunityData);
		}
	}, [currentIndex, orgTeam])

	useEffect(() => {
		if (currentIndex >= 0 || opportunityData) {
			getEditData(opportunityData)
		}
	}, [currentIndex, opportunityData])

	const getEditData = (opportunityDetails) => {
		if (opportunityDetails) {
			const edit = _.cloneDeep(opportunityDetails);

			if (edit?.advisor?.length > 0) {
				edit.advisor[currentIndex].advisor_relationship_manager = props.relationshipOwner.filter(
					(item) => item._id === opportunityDetails?.advisor[currentIndex].advisor_relationship_manager
				)[0];

				edit.advisor[currentIndex].advisor_history = props.advisorHistory.filter(
					(item) => item.label === opportunityDetails?.advisor[currentIndex].advisor_history
				)[0];

				edit.advisor[currentIndex].depth_of_advisor_engagement = props.depthOfAdvisorEngagement.filter(
					(item) => item.label === opportunityDetails?.advisor[currentIndex].depth_of_advisor_engagement
				)[0];
			}

			setEditData(edit);
		}
	}

	const loadWiderStakeholder = async () => {
		try {
			// Fetch advisors and organisations
			const response = await getAdvisorsAndOrgs(props.customerId, opportunityData.branch_id);

			if (response.data && response.data.success) {
				let organisations = [];
				let advisors = [];

				// Process organisations data
				if (response.data.organisations) {
					organisations = response.data.organisations.map(org => ({
						organisation_id: org._id,
						organisation_name: org.organisation_name,
					}));
				}

				// Process client data (considered as organisations)
				if (response.data.client) {
					organisations = organisations.concat(
						response.data.client.map(client => ({
							organisation_id: client._id,
							organisation_name: client.client_name,
						}))
					);
				}

				// Process advisors data
				if (response.data.advisors) {
					advisors = response.data.advisors.map(advisor => ({
						id: advisor._id,
						label: advisor.advisor_name,
					}));
				}

			}

			setCheckedCheckboxes({});
			setModelOpen(true);

		} catch (error) {
			toastRef.current.showToast({
				type: "error",
				message: "Failed to load stakeholders. Please try again or contact Admin.",
			});
		}
	};


	useEffect(() => {
		if (props.opportunityData && orgTeam.length > 0) {
			cliTeamMemberDetails(props.opportunityData, orgTeam)
		}
	}, [props.opportunityData, orgTeam])

	const loadTeamMember = () => {
		setCheckedCheckboxes({});
		setTeamModelOpen(true);
	}

	const handleHide = (data) => {
		setSelectedOption('');
		setStakeVisible(data);
	}

	const handleTeamHide = (data) => {
		setTeamVisible(data);
	}

	const closeProgrammDialog = () => {
		setModelOpen(false);
		setSelectedOption([])
		setValue("client_name", "")
	};

	const closeTeamDialog = () => {
		setTeamModelOpen(false);
		setSelectedOption([]);
		setValue("team", "")
	}

	const handleRadioChange = (value) => {
		setSelectedOption(value);
		if (value === 'new') {
			setStakeVisible(true);
			setTeamVisible(true);
		}
	};

	const getStatkeHolderDetails = async () => {
		try {
			// Checking if branch_id exists before making the API call
			if (props.branch?.branch_id) {
				let data = {
					skip: 0,
					limit: 'All',
					cust_id: props.customerId,
					branch: props.branch,
					pattern: "All",
					sortBy: 'client_name',
					orderBy: 1,
					filterData: {
						filter: 'All',
						branch_id: [],
						client_classification: [],
						relationship_owner: [],
						client_type: [],
						sector: [],
						stakeholder_status: [],
						business_unit: [],
						region: [],
						main_board_sponsor: []
					}
				};

				setLoading(true);

				// Fetch the stakeholder details from the API
				const stakeholderDetail = await fil(
					data.skip,
					data.limit,
					data.cust_id,
					data.branch,
					data.pattern,
					data.sortBy,
					data.orderBy,
					data.filterData
				);

				// Successfully fetched data, set the stakeholder details
				setStakeHolderDetails(stakeholderDetail?.data?.client);
			} else {
				// Show a custom toast warning if no branch ID is provided
				toastRef.current.showToast({
					type: "error",
					message: "Branch ID is missing. Please select a branch to proceed.",
				});
			}
		} catch (error) {

			toastRef.current.showToast({
				type: "error",
				message: "Error fetching stakeholder details. Please try again or contact Admin.",
			});
		} finally {
			setLoading(false);
		}
	};


	const getTeamMember = async (opportunityDetails) => {
		try {
			const advlength = opportunityDetails?.advisor?.length;

			// Proceed only if there are advisors available
			if (advlength > 0) {
				const lastAdvisor = opportunityDetails.advisor[currentIndex];
				setAdvIndex(currentIndex);
				setOrganisationId(opportunityDetails?.client_id);

				// Fetch organization team details if organisation_id exists
				if (lastAdvisor) {
					const response = await getOrgTeam(lastAdvisor?.advisor_adv, props?.customerId);

					if (response.data?.organisation) {
						setOrgTeam(response.data.organisation);
					} else {
						// Show a toast message if no organization data is found
						toastRef.current.showToast({
							type: "error",
							message: "No organization data found. Please try again.",
						});
					}
				}
			}
		} catch (error) {
			toastRef.current.showToast({
				type: "error",
				message: "Error fetching team members. Please try again or contact Admin.",
			});
		}
	};

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className='align-center justify-end pb-0'>
					<ButtonElement type="button" className="save-button" label="Add" onClick={addStakeholder} />
				</div>
			</div>
		);
	};

	const addNewMembers = async (teamData) => {
		try {
			// Check if teamData exists and is valid
			if (teamData && teamData.first_name && teamData.last_name && teamData.email) {
				// Update teamData properties
				teamData.organisation_team = `${teamData.first_name} ${teamData.last_name}`;
				teamData.full_name = teamData.organisation_team;
				teamData.email = teamData.email.toLowerCase();

				// Get organisation details from the current advisor
				const organisation_id = opportunityData.advisor[currentIndex]?.advisor_adv || undefined;
				const organisation_name = opportunityData.advisor[currentIndex]?.advisor_name || undefined;

				// Call API to add new team member
				const response = await addNewMember(opportunityData._id, organisation_id, organisation_name, props.customerId, currentIndex, teamData);

				// Handle the API response
				if (response.data) {
					if (response.data.success) {
						toastRef.current.showToast({
							type: 'success',
							message: response.data.message,
						});

						opportunityData.advisor[currentIndex].advisor_team = response.data.result;
						setOpportunityData(opportunityData);

						props.getData('success');
						getTeamMember(opportunityData);
						cliTeamMemberDetails(opportunityData, orgTeam);
						setGlobalOpportunityData((prevData) => ({
							...prevData,
							opportunityData,
						}));

						setSelectedOption([]);
						setValue("team", "")
						setTeamModelOpen(false);
					} else {
						toastRef.current.showToast({
							type: 'error',
							message: response.data.message,
						});
					}
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: 'Fields are required or invalid.',
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'Failed to add new member. Please try again or contact Admin.',
			});
		}
	};


	const cliTeamMemberDetails = (opportunityDetails, orgData) => {
		if (opportunityDetails?.advisor[currentIndex]?.advisor_team?.length >= 1) {
			for (var i = 0; i < opportunityData?.advisor[currentIndex]?.advisor_team?.length; i++) {
				orgData.forEach((value) => {
					if (value._id === opportunityData.advisor[currentIndex]?.advisor_team[i]?.organisation_team_id) {
						opportunityDetails.advisor[currentIndex].advisor_team[i].organisation_team = value.full_name;
					}
				});
			}
		}
		setOpportunityData(prevState => ({
			...prevState,
			opportunityDetails
		}))
	}




	const addTeamMember = async () => {
		try {
			// Get the selected team member
			const selectedTeamMember = getValues("team");

			if (!_.isEmpty(selectedTeamMember)) {
				// API call to update the existing member
				const data = await updateExistingMember(
					opportunityData._id,
					props.customerId,
					currentIndex,
					opportunityData.advisor[currentIndex]._id,
					selectedTeamMember
				);

				if (data.data) {
					if (data.data.success && (data.data.status === 'success' || data.data.status === 'warning')) {
						// Update advisor team data in opportunityData
						opportunityData.advisor[currentIndex].advisor_team = data.data.result;

						// Update team members if the advisor team is not empty
						if (opportunityData.advisor[currentIndex].advisor_team.length >= 1) {
							const updatedTeam = opportunityData.advisor[currentIndex].advisor_team.map(teamMember => {
								const matchedOrg = orgTeam.find(org => org._id === teamMember.organisation_team_id);
								if (matchedOrg) {
									teamMember.organisation_team = matchedOrg.full_name;
									selectedTeamMem.push(matchedOrg);
								}
								return teamMember;
							});
							setSelectedTeamMem([...selectedTeamMem]);
						}

						setOpportunityData({ ...opportunityData });

						toastRef.current.showToast({
							type: 'success',
							message: data.data.message,
						});

						props.getData('success');
						cliTeamMemberDetails(opportunityData, orgTeam);
						setSelectedOption([]);
						setValue("team", "")
						setTeamModelOpen(false);
					} else {
						toastRef.current.showToast({
							type: 'error',
							message: data.data.message,
						});
					}
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: 'Please select at least one team member',
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'Failed to add team member. Please try again or contact Admin.',
			});
		}
	};



	const renderTeamFooter = () => {
		return (
			<div className="cancel-footer">
				<div className='align-center justify-end pb-0'>
					<ButtonElement type="button" className="save-button" label="Add" onClick={addTeamMember} />
				</div>
			</div>
		);
	};

	const rowClickStake = async (data) => {
		setSelectedRow(data)
	};

	const removeTeamField = async (data) => {
		setSelectedTeamRow(data);
	}

	const deleteField = () => {
		const updatedOptions = opportunityData.advisor.filter(
			(row) => !selectedRow.includes(row)
		);
		setOpportunityData((prevState) => ({
			...prevState,
			advisor: updatedOptions,
		}));
		setSelectedRow([]);
	};


	const addStakeholder = async (clientData, clientId) => {
		try {
			setLoading(true);

			let selectedStakeholder = {};

			// Checking if clientData is an object and clientId is provided
			if (typeof clientData === 'object' && clientId !== undefined) {
				clientData._id = clientId;
				selectedStakeholder = clientData;
			} else {
				selectedStakeholder = getValues("client_name");
			}

			// Ensure the selected option is valid
			if (selectedOption !== '') {
				if (selectedStakeholder && selectedStakeholder.client_name) {
					const data = await addExistingAdvisor(
						opportunityData._id,
						props.customerId,
						selectedStakeholder._id,
						selectedStakeholder
					);

					// Handle the response
					if (data.data) {
						if (data.data.success) {
							toastRef.current.showToast({
								type: 'success',
								message: data.data.message,
							});
							props.getData('success');
							setModelOpen(false);
							setSelectedOption([])
							setValue("client_name", "")
						} else {
							toastRef.current.showToast({
								type: 'error',
								message: data.data.message,
							});
						}
					}
				} else {
					// Error: Invalid stakeholder organisation
					toastRef.current.showToast({
						type: 'error',
						message: 'Enter a valid stakeholder organisation.',
					});
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: 'Select at least one stakeholder.',
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'Failed to add stakeholder. Please try again or contact Admin.',
			});
		} finally {
			setLoading(false);
		}
	};

	const deleteTeamField = () => {
		const updatedOptions = opportunityData.advisor[currentIndex].advisor_team.filter(
			(row) => !selectedTeamRow.includes(row)
		);

		const updatedAdvisor = opportunityData.advisor.map((advisor, index) =>
			index === currentIndex ? { ...advisor, advisor_team: updatedOptions } : advisor
		);

		setOpportunityData((prevState) => ({
			...prevState,
			advisor: updatedAdvisor,
		}));
		setSelectedTeamRow([]);
	};

	/**
	   * Function to check and render the display name or option names based on availability in the row data.
	   * @param {Object} rowData - The data of the row being rendered.
	   * @returns {JSX.Element} - The JSX element containing the display name or option names.
	   */

	const checkingDisplayName = (rowData) => {
		if (rowData.advisor_name != null && rowData.advisor_name !== "") {
			return <div>{rowData.advisor_name}</div>;
		} 
		else {
			// If display name doesn't exist or is empty, render option names
			return <div>No Results Found</div>;
		}
	};

	const checkingSectorName = (rowData) => {
		if (rowData.advisor_sector.length > 0) {
			return (
				<div>
					{rowData.advisor_sector?.map((item, index) => (
						<li key={index}>
							{item.label}
						</li>
					))}
				</div>
			);
		} else {
			return ""
		}
	};

	const onChangeLead = (position, entities) => {
		const updatedEntities = entities.map((subscription, index) => {
			return {
				...subscription,
				advisor_lead: position === index
			};
		});

		// Ensure that you are updating the state with a new object reference
		setOpportunityData(prevOpportunityData => ({
			...prevOpportunityData,
			advisor: updatedEntities
		}));
	}

	const checkingLead = (rowData, index) => {
		return (
			<RadioElement
				id="lead"
				options={[{ key: true, name: "" }]}
				value={rowData.advisor_lead}
				onChangeRadio={(e) => onChangeLead(index.rowIndex, opportunityData.advisor)}
				className="radio-group-class"
			/>
		)
	}

	const checkingRelationShipOwner = (rowData) => {
		if (rowData.advisor_relationship_manager != null && rowData.advisor_relationship_manager !== "") {
			var new_data = props.relationshipOwner.filter(
				(item) => item._id === rowData.advisor_relationship_manager
			)[0];
			return (
				<div>
					{new_data != undefined ? new_data.label : rowData.advisor_relationship_manager}
				</div>
			);
		}
	}

	const checkingClientType = (rowData) => {
		if (rowData.advisor_sector.length > 0) {
			return (
				<div>
					{rowData.advisor_type?.map((item, index) => (
						<li key={index}>
							{item.label}
						</li>
					))}
				</div>
			);
		} else {
			return ""
		}
	}

	const checkingTeamDisplayName = (rowData) => {
		if (rowData.organisation_team != null && rowData.organisation_team !== "") {
			return <div>{rowData.organisation_team}</div>;
		} 
		// else {
		// 	// If display name doesn't exist or is empty, render option names
		// 	return <div>No Results Found</div>;
		// }
	};


	const onChangeLeadName = (position, entities) => {
		const updatedEntities = entities.map((subscription, index) => {
			return {
				...subscription,
				lead: position === index
			};
		});

		setOpportunityData((prevOpportunityData) => ({
			...prevOpportunityData,
			advisor: prevOpportunityData.advisor.map((advisor, index) =>
				index === currentIndex
					? {
						...advisor,
						advisor_team: updatedEntities,
					}
					: advisor
			),
		}));
	}

	const checkingLeadName = (rowData, index) => {
		return (
			<RadioElement
				id="lead"
				options={[{ key: true, name: "" }]}
				value={rowData.lead}
				onChangeRadio={(e) => onChangeLeadName(index.rowIndex, opportunityData.advisor[currentIndex].advisor_team)}
				className="radio-group-class"
			/>
		)
	};

	const handleInputChange = (e, rowIndex) => {
		const advisorIndex = currentIndex;
		const teamIndex = rowIndex;

		setOpportunityData((prevOpportunityData) => ({
			...prevOpportunityData,
			advisor: prevOpportunityData.advisor.map((advisor, index) => {
				if (index === advisorIndex) {
					return {
						...advisor,
						advisor_team: advisor.advisor_team.map((teamMember, tIndex) => {
							if (tIndex === teamIndex) {
								return {
									...teamMember,
									specific_individual_needs: e.target.value,
								};
							}
							return teamMember;
						}),
					};
				}
				return advisor;
			}),
		}));

	}



	const checkingSPN = (rowData, index) => {
		return (
			<InputTextElementElement
				id="specific_individual_needs"
				name="specific_individual_needs"
				value={rowData.specific_individual_needs}
				onChange={e => handleInputChange(e, index.rowIndex)}
				className="w-full"
			/>
		)
	};

	const handlePrevious = () => {
		setCurrentIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : opportunityData.advisor.length - 1));
	};

	const handleNext = () => {
		setCurrentIndex(prevIndex => (prevIndex < opportunityData.advisor.length - 1 ? prevIndex + 1 : 0));
	};

	const columns = [
		{
			field: 'advisor_name',
			header: _.find(props?.stakeholderData?.oppListStakeholdersHeaders, { header_name: "Name" })?.display_name,
			body: checkingDisplayName,
			style: { width: "20%" },
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'advisor_sector',
			header: _.find(props.stakeholderData?.commanFieldsNew, { field_name: "Sector" })?.display_name,
			body: checkingSectorName,
			style: { width: "20%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'advisor_lead',
			header: _.find(props.stakeholderData?.oppClientHeaders, { header_name: "Lead" })?.display_name,
			body: checkingLead,
			style: { width: "20%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'advisor_relationship_manager',
			header: _.find(props.stakeholderData?.commanFieldsNew, { field_name: "Relationship Owner" })?.display_name,
			body: checkingRelationShipOwner,
			style: { width: "20%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'advisor_type',
			header: _.find(props.stakeholderData?.clientFieldsNew, { field_name: "Client Type" })?.display_name,
			body: checkingClientType,
			style: { width: "20%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
	]

	const teamColumns = [
		{
			field: 'organisation_team',
			header: _.find(props?.stakeholderData?.oppIndiStakeholdersHeaders, { header_name: "Team Member" })?.display_name,
			body: checkingTeamDisplayName,
			style: { width: "40%" },
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'lead',
			header: _.find(props?.stakeholderData?.oppIndiStakeholdersHeaders, { header_name: "Lead" })?.display_name,
			body: checkingLeadName,
			style: { width: "20%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
		{
			field: 'specific_individual_needs',
			header: _.find(props.stakeholderData?.oppIndiStakeholdersHeaders, { header_name: "Specific Individual Needs" })?.display_name,
			body: checkingSPN,
			style: { width: "40%" }, // Inline style for the column
			headerClassName: "header-datatable",
			className: 'row-datatable'
		}
	]

	const onTextChangeNeeds = (index, field) => (e) => {
		const newDocumentName = [...opportunityData?.advisor[currentIndex]?.advisor_needs];

		newDocumentName[index][field] = e.target.value;
		const updatedAdvisor = opportunityData.advisor.map((advisor, i) =>
			i === currentIndex ? { ...advisor, advisor_needs: newDocumentName } : advisor
		);

		setOpportunityData((prevState) => ({
			...prevState,
			advisor: updatedAdvisor,
		}));
	};

	const onTextChangeObjectives = (index, field) => (e) => {
		const newAdvisorNeeds = [...opportunityData?.advisor[currentIndex]?.advisor_objectives];

		newAdvisorNeeds[index][field] = e.target.value;
		const updatedAdvisor = opportunityData.advisor.map((advisor, i) =>
			i === currentIndex ? { ...advisor, advisor_objectives: newAdvisorNeeds } : advisor
		);

		setOpportunityData((prevState) => ({
			...prevState,
			advisor: updatedAdvisor,
		}));
	};

	const onTextChangeValues = (index, field) => (e) => {
		const newAdvisorValues = [...opportunityData?.advisor[currentIndex]?.advisor_values];

		newAdvisorValues[index][field] = e.target.value;
		const updatedAdvisor = opportunityData.advisor.map((advisor, i) =>
			i === currentIndex ? { ...advisor, advisor_values: newAdvisorValues } : advisor
		);

		setOpportunityData((prevState) => ({
			...prevState,
			advisor: updatedAdvisor,
		}));
	};

	const needsEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElement
					className={(props.errors.includes('Stakeholder Needs') && row.needs == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
					value={row.needs}
					placeholder="Description"
					onChange={onTextChangeNeeds(index?.rowIndex, "needs")}
				/>
			</div>
		);
	};

	const objectivesEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElement
					className={(props.errors.includes('Stakeholder Objectives') && row.objectives == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
					value={row.objectives}
					placeholder="Description"
					onChange={onTextChangeObjectives(index?.rowIndex, "objectives")}
				/>
			</div>
		);
	};

	const valuesEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElement
					className={(props.errors.includes('Stakeholder Values') && row.values == '') ? 'error-tab dropdown-field-handle' : 'dropdown-field-handle'}
					value={row.values}
					placeholder="Description"
					onChange={onTextChangeValues(index?.rowIndex, "values")}
				/>
			</div>
		);
	};

	const outputColumns = [
		{
			field: "needs",
			header: _.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Outputs" })?.display_name,
			body: needsEditor,
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
	]

	const objectivesColumns = [
		{
			field: "advisor_objectives",
			header: _.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Deliverables" })?.display_name,
			body: objectivesEditor,
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
	]

	const valuesColumns = [
		{
			field: "advisor_values",
			header: _.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Performance" })?.display_name,
			body: valuesEditor,
			headerClassName: "header-datatable",
			className: 'row-datatable'
		},
	]

	function generateRandomID() {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}


	const rowClick1 = async (data) => {
		setSelectedOptionNeeds(data)
	};
	const rowClick2 = async (data) => {
		setSelectedOptionObjectives(data)
	};

	const rowClick3 = async (data) => {
		setSelectedOptionValues(data)
	};
	
	const [option, setOption] = useState([
		{ id: "", needs: "" },
	]);

	const [optionObjective, setOptionObjective] = useState([
		{ id: "", objectives: "" },
	]);

	const [optionValues, setOptionValues] = useState([
		{ id: "", values: "" },
	]);

	const addItem = () => {
		const newRow = {
			_id: generateRandomID(),
			needs: ""
		};
		setOption([...option, newRow]);

		const updatedOpportunityData = {
			...opportunityData,
			advisor: opportunityData.advisor.map((advisor, index) =>
				index === currentIndex
					? {
						...advisor,
						advisor_needs: [...advisor.advisor_needs, newRow]
					}
					: advisor
			)
		};
		setOpportunityData(updatedOpportunityData);
	};

	const addItemObjectives = () => {
		const newRow = {
			_id: generateRandomID(),
			objectives: ""
		};
		setOptionObjective([...option, newRow]);

		const updatedOpportunityData = {
			...opportunityData,
			advisor: opportunityData.advisor.map((advisor, index) =>
				index === currentIndex
					? {
						...advisor,
						advisor_objectives: [...advisor.advisor_objectives, newRow]
					}
					: advisor
			)
		};
		setOpportunityData(updatedOpportunityData);
	};

	const addItemValues = () => {
		const newRow = {
			_id: generateRandomID(),
			values: ""
		};
		setOptionValues([...option, newRow]);

		const updatedOpportunityData = {
			...opportunityData,
			advisor: opportunityData.advisor.map((advisor, index) =>
				index === currentIndex
					? {
						...advisor,
						advisor_values: [...advisor.advisor_values, newRow]
					}
					: advisor
			)
		};
		setOpportunityData(updatedOpportunityData);
	};

	const handleDeleteOption = () => {
		const updatedOptions = opportunityData.advisor[currentIndex].advisor_needs.filter(
			(row) => !selectedOptionNeeds.includes(row)
		);
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[currentIndex] = {
				...updatedAdvisor[currentIndex],
				advisor_needs: updatedOptions,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
		setSelectedOptionNeeds([]);
	};

	const handleDeleteObjectivesOption = () => {
		const updatedOptions = opportunityData.advisor[currentIndex].advisor_objectives.filter(
			(row) => !selectedOptionObjectives.includes(row)
		);
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[currentIndex] = {
				...updatedAdvisor[currentIndex],
				advisor_objectives: updatedOptions,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
		setSelectedOptionObjectives([]);
	};

	const handleDeleteValuesOption = () => {
		const updatedOptions = opportunityData.advisor[currentIndex].advisor_values.filter(
			(row) => !selectedOptionValues.includes(row)
		);
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[currentIndex] = {
				...updatedAdvisor[currentIndex],
				advisor_values: updatedOptions,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
		setSelectedOptionValues([]);
	};

	const handleRelationship = (e, index) => {
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[index] = {
				...updatedAdvisor[index],
				advisor_relationship_manager: e.value._id,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
	}

	const handleDepth = (e, index) => {
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[index] = {
				...updatedAdvisor[index],
				depth_of_advisor_engagement: e.value.label,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
	}

	const handleHistory = (e, index) => {
		setOpportunityData((prevState) => {
			const updatedAdvisor = [...prevState.advisor];
			updatedAdvisor[index] = {
				...updatedAdvisor[index],
				advisor_history: e.value.label,
			};
			return {
				...prevState,
				advisor: updatedAdvisor,
			};
		});
	}

	// const generateAdvisorReport = async () => {
	// 	try {
	// 		const response = await generateAdvisor(opportunityData._id, props.customerId, opportunityData.advisor);
	// 		if (response.data) {
	// 			downloadDocs(response.data.fileName, token);
	// 		}
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }
	const generateAdvisorReport = async () => {
		try {
			setLoading(true);

			// Call API to generate advisor report
			const response = await generateAdvisor(opportunityData._id, props.customerId, opportunityData.advisor);

			if (response.data) {
				// Download the generated report
				downloadDocs(response.data.fileName);

				toastRef.current.showToast({
					type: 'success',
					message: 'Advisor report generated and downloaded successfully',
				});
			}
		} catch (error) {
			toastRef.current.showToast({
				type: 'error',
				message: 'Failed to generate advisor report. Please try again or contact Admin.',
			});
		} finally {
			setLoading(false);
		}
	};


	return (
		<div className='new-field'>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="form-group row align-items-center mb-0">
				<div className="col-md-4 pl-0">
					<p className='label-text'>{_.find(props.stakeholderData?.projectStakeTabSections, { section_name: "Stakeholders" })?.display_name}</p>
				</div>
				<div className="col-md-8 text-right">
					<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
				</div>
			</div>
			{
				_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "List of Design Team Members" })?.status &&
				<div className="box-border mt-10">
					<div className="form-group row align-items-center mb-0">
						<div className="col-md-6 pl-0">
							<p className="label-text">
								{_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "List of Design Team Members" })?.display_name}
							</p>
						</div>
						<div className="col pr-0 d-flex justify-end">
							<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={() => deleteField()} />
							<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={loadWiderStakeholder} />
						</div>
					</div>
					<div>
						<DataTable
							value={opportunityData != undefined ? (opportunityData?.advisor && opportunityData?.advisor.length > 0) ? opportunityData?.advisor : [] : []}
							columns={columns}
							dataKey="_id"
							isNotReorder={true}
							rowClick={rowClickStake}
						/>
					</div>
				</div>
			}
			{
				opportunityData != undefined && opportunityData.advisor && opportunityData.advisor.length > 0 && (
					<>
						<div className="form-group row align-items-center mb-0 mt-20">
							<div className="col-md-8 pl-0 pt-17">
								<p className="sub-label-text">
									{opportunityData.advisor[currentIndex]?.advisor_name}
								</p>
							</div>
							<div className="col pr-0 d-flex justify-end">
								<ButtonElement className="edit-option-button" type="button" icon="pi pi-chevron-left" onClick={handlePrevious} />
								<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-chevron-right" onClick={handleNext} />
							</div>
						</div>
						{
							opportunityData != undefined && opportunityData.advisor && opportunityData.advisor.length > 0 && !_.isEmpty(editData) && Object.entries(newModule).map(([key, value]) => (
								<div key={key} className='mt-10'>
									<Accordion activeIndex={0}>
										{
											<AccordionTab header={value} disabled>
												{
													key == 'obj1' &&
													<div className="new-field d-flex">
														<div className='col pl-0'>
															{
																_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Individual Stakeholder" })?.status &&
																<div className="box-border">
																	<div className="form-group row align-items-center mb-0">
																		<div className="col-md-6 pl-0">
																			<p className="label-text">
																				{_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Individual Stakeholder" })?.display_name}
																			</p>
																		</div>
																		<div className="col pr-0 d-flex justify-end">
																			<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={() => deleteTeamField()} />
																			<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={loadTeamMember} />
																		</div>
																	</div>
																	<div>
																		<DataTable
																			value={opportunityData.advisor[currentIndex].advisor_team}
																			columns={teamColumns}
																			dataKey="_id"
																			isNotReorder={true}
																			rowClick={removeTeamField}
																		/>
																	</div>
																</div>
															}
														</div>
													</div>
												}
												{
													key == 'obj2' &&
													<div className="new-field d-flex">
														<div className='col pl-0'>
															{
																_.find(props.stakeholderData?.orgFieldsNew, { field_name: "Organisation Name" })?.field_status === true &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.stakeholderData?.orgFieldsNew, { field_name: "Organisation Name" })?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																	</div>
																	<div className='col pr-0'>
																		<label className="form-label text-left">{opportunityData?.advisor[currentIndex]?.advisor_organisation}</label>
																	</div>
																</div>
															}
															{
																_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Classification" })?.field_status === true &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Classification" })?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																	</div>
																	<div className='col pr-0'>
																		<label className="form-label text-left">{opportunityData?.advisor[currentIndex]?.advisor_classification?.map((item, index) => (
																			<li key={index}>
																				{item.label}
																			</li>
																		))}</label>
																	</div>
																</div>
															}
															{
																_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Type" })?.field_status === true &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Type" })?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																	</div>
																	<div className='col pr-0'>
																		<label className="form-label text-left">{opportunityData?.advisor[currentIndex]?.advisor_type?.map((item, index) => (
																			<li key={index}>
																				{item.label}
																			</li>
																		))}</label>
																	</div>
																</div>
															}
															{
																_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Relationship Manager" })?.field_status === true &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className="col-md-4 pl-0">
																		<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder Relationship Manager" })?.display_name}:</label>
																	</div>
																	<div className="col-md-1 pl-0">
																		{
																			props.customerTooltipDataOthers?.stakeholder.advisor_relationship_manager.status == true &&
																			<div>
																				<Tooltip target=".custom-target-icon" />

																				<i className="custom-target-icon pi pi-info-circle tooltip-font"
																					data-pr-tooltip={props.customerTooltipDataOthers?.stakeholder.advisor_relationship_manager.text}
																					data-pr-position="right">
																				</i>
																			</div>
																		}
																	</div>
																	<div className='col pr-0'>
																		<DropdownElement
																			key={currentIndex}
																			id="advisor_relationship_manager"
																			options={(props.relationshipOwner != undefined && props.relationshipOwner.length > 0) ? props.relationshipOwner : []}
																			value={editData.advisor[currentIndex].advisor_relationship_manager}
																			optionLabel="label"
																			placeholder="-- Please select --"
																			className="w-full"
																			onChange={(e) => {
																				handleRelationship(e, currentIndex);
																			}}
																		/>
																	</div>
																</div>
															}
														</div>
													</div>
												}
												{
													key == 'obj3' &&
													<div>
														<div className="new-field d-flex">
															<div className='col-md-6 pl-0'>
																{
																	_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder History" })?.field_status === true &&
																	<div className="form-group row align-items-center mb-0 mt-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholder History" })?.display_name}:</label>
																		</div>
																		<div className="col-md-1 pl-0">
																			{
																				props.customerTooltipDataOthers?.stakeholder.advisor_history.status == true &&
																				<div>
																					<Tooltip target=".custom-target-icon" />
																					<i className="custom-target-icon pi pi-info-circle tooltip-font"
																						data-pr-tooltip={props.customerTooltipDataOthers?.stakeholder.advisor_history.text}
																						data-pr-position="right">
																					</i>
																				</div>
																			}
																		</div>
																		<div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
																			<DropdownElement
																				id="advisor_history"
																				options={(props?.advisorHistory != undefined && props?.advisorHistory.length > 0) ? props?.advisorHistory : []}
																				placeholder="-- Please select --"
																				className="w-full"
																				maxSelectedLabels={1}
																				value={editData.advisor[currentIndex]?.advisor_history}
																				onChange={(e) => {
																					handleHistory(e, currentIndex)
																					setGlobalOpportunityData((prevData) => ({
																						...prevData,
																						advisor: prevData.advisor?.map((advisor, index) => {
																							if (index === currentIndex) {
																								return {
																									...advisor,
																									advisor_history: e.value.label
																								};
																							}
																							return advisor;
																						}),
																					}));
																				}}
																				optionLabel="label"
																			/>
																		</div>
																	</div>
																}
																{
																	_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Depth of Stakeholder Engagement" })?.field_status === true &&
																	<div className="form-group row align-items-center mb-0 mt-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Depth of Stakeholder Engagement" })?.display_name}:</label>
																		</div>
																		<div className="col-md-1 pl-0">
																			{
																				props.customerTooltipDataOthers?.stakeholder.depth_of_advisor_engagement.status == true &&
																				<div>
																					<Tooltip target=".custom-target-icon" />
																					<i className="custom-target-icon pi pi-info-circle tooltip-font"
																						data-pr-tooltip={props.customerTooltipDataOthers?.stakeholder.depth_of_advisor_engagement.text}
																						data-pr-position="right">
																					</i>
																				</div>
																			}
																		</div>
																		<div className='col-md-7 pr-0 pad-t-8 pad-b-8'>
																			<DropdownElement
																				id="DepthOfAdvisorEngagement"
																				name="DepthOfAdvisorEngagement"
																				options={(props?.depthOfAdvisorEngagement != undefined && props?.depthOfAdvisorEngagement.length > 0) ? props?.depthOfAdvisorEngagement : []}
																				optionLabel="label"
																				placeholder="-- Please select --"
																				className="w-full"
																				maxSelectedLabels={1}
																				value={editData.advisor[currentIndex]?.depth_of_advisor_engagement}
																				// ref={(el) => {
																				// 	props.setElement((prevData) => ({
																				// 		...prevData,
																				// 		["DepthOfAdvisorEngagement"]: el,
																				// 	}));
																				// }}
																				onChange={(e) => {
																					handleDepth(e, currentIndex);
																					setGlobalOpportunityData((prevData) => ({
																						...prevData,
																						advisor: prevData.advisor?.map((advisor, index) => {
																							if (index === currentIndex) {
																								return {
																									...advisor,
																									depth_of_advisor_engagement: e.value.label,
																								};
																							}
																							return advisor;
																						}),
																					}));
																					props.computeScore(0, "DepthOfAdvisorEngagement", e.value, editData.advisor[currentIndex]?.depth_of_advisor_engagement);
																				}}
																			/>
																		</div>
																	</div>
																}
																{
																	_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholders Project Priorities" })?.field_status === true &&
																	<div className="form-group row align-items-center mb-0 mt-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholders Project Priorities" })?.display_name}:</label>
																		</div>
																		<div className="col-md-1 pl-0">
																			{
																				props.customerTooltipDataOthers?.stakeholder.advisor_drivers.status == true &&
																				<div>
																					<Tooltip target=".custom-target-icon" />
																					<i className="custom-target-icon pi pi-info-circle tooltip-font"
																						data-pr-tooltip={props.customerTooltipDataOthers?.stakeholder.advisor_drivers.text}
																						data-pr-position="right">
																					</i>
																				</div>
																			}
																		</div>
																		<div className='col pr-0'>
																			<TextareaElement
																				placeholder="Text"
																				name="project_priorities"
																				className="w-full"
																				value={opportunityData.advisor[currentIndex].advisor_drivers ? opportunityData.advisor[currentIndex].advisor_drivers : ''}
																				rows={3}
																				onChange={(e) => {
																					setOpportunityData((prevData) => ({
																						...prevData,
																						advisor: prevData.advisor?.map((advisor, index) => {
																							if (index === currentIndex) {
																								return {
																									...advisor,
																									advisor_drivers: e.target.value
																								};
																							}
																							return advisor;
																						})
																					}));
																				}}
																			/>
																		</div>
																	</div>
																}
																{
																	_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholders Project Brief" })?.field_status === true &&
																	<div className="form-group row align-items-center mb-0 mt-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left">{_.find(props.stakeholderData?.pipelineStakeFields, { field_name: "Stakeholders Project Brief" })?.display_name}:</label>
																		</div>
																		<div className="col-md-1 pl-0">
																			{
																				props.customerTooltipDataOthers?.stakeholder.advisor_brief.status == true &&
																				<div>
																					<Tooltip target=".custom-target-icon" />
																					<i className="custom-target-icon pi pi-info-circle tooltip-font"
																						data-pr-tooltip={props.customerTooltipDataOthers?.stakeholder.advisor_brief.text}
																						data-pr-position="right">
																					</i>
																				</div>
																			}
																		</div>
																		<div className='col pr-0'>
																			<TextareaElement
																				placeholder="Text"
																				name="project_brief"
																				className="w-full"
																				value={opportunityData.advisor[currentIndex].advisor_brief ? opportunityData.advisor[currentIndex].advisor_brief : ''}
																				rows={3}
																				onChange={(e) => {
																					setOpportunityData((prevData) => ({
																						...prevData,
																						advisor: prevData.advisor?.map((advisor, index) => {
																							if (index === currentIndex) {
																								return {
																									...advisor,
																									advisor_brief: e.target.value
																								};
																							}
																							return advisor;
																						})
																					}));
																				}}
																			/>
																		</div>
																	</div>
																}
															</div>
															<div className="col-md-6 pl-0">
																{
																	_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Outputs" })?.status &&
																	<div className="col pl-0 box-border-plan ml-10">
																		<div className="form-group row align-items-center mb-0 mt-0">
																			<div className="col pr-0 pt-0">
																				<div className="form-group row align-items-center mb-0">
																					<div className="col pr-0 d-flex justify-end">
																						<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOption} />
																						<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItem} />
																					</div>
																				</div>
																				<DataTable
																					value={opportunityData?.advisor[currentIndex]?.advisor_needs}
																					columns={outputColumns}
																					dataKey="_id"
																					isNotReorder={true}
																					rowClick={rowClick1}
																				/>
																			</div>
																		</div>
																	</div>
																}
															</div>
														</div>
														<div className="new-field d-flex mt-20">
															<div className='col-md-6 pl-0'>
																{
																	_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Deliverables" })?.status &&
																	<div className="col pl-0 box-border-plan ml-10">
																		<div className="form-group row align-items-center mb-0 mt-0">
																			<div className="col pr-0 pt-0">
																				<div className="form-group row align-items-center mb-0">
																					<div className="col pr-0 d-flex justify-end">
																						<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteObjectivesOption} />
																						<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemObjectives} />
																					</div>
																				</div>
																				<DataTable
																					value={opportunityData?.advisor[currentIndex]?.advisor_objectives}
																					columns={objectivesColumns}
																					dataKey="_id"
																					isNotReorder={true}
																					rowClick={rowClick2}
																				/>
																			</div>
																		</div>
																	</div>
																}
															</div>
															<div className='col-md-6 pl-0'>
																{
																	_.find(props.stakeholderData?.oppStakeholdersTable, { table_name: "Specific Project Performance" })?.status &&
																	<div className="col pl-0 box-border-plan ml-10">
																		<div className="form-group row align-items-center mb-0 mt-0">
																			<div className="col pr-0 pt-0">
																				<div className="form-group row align-items-center mb-0">
																					<div className="col pr-0 d-flex justify-end">
																						<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteValuesOption} />
																						<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemValues} />
																					</div>
																				</div>
																				<DataTable
																					value={opportunityData?.advisor[currentIndex]?.advisor_values}
																					columns={valuesColumns}
																					dataKey="_id"
																					isNotReorder={true}
																					rowClick={rowClick3}
																				/>
																			</div>
																		</div>
																	</div>
																}
															</div>
														</div>
													</div>
												}
											</AccordionTab>
										}
									</Accordion>
								</div>
							))
						}
					</>
				)
			}
			<Dialog
				visible={isModelOpen}
				breakpoints={{ "960px": "75vw", "641px": "90vw" }}
				header="Add"
				modal
				position="center"
				onHide={closeProgrammDialog}
				footer={renderFooter()}
				className='width-32'
				draggable={false}
			>
				<div className='new-field'>
					<RadioElement
						id="stakeholder"
						options={[{ key: 'new', name: "Add new Stakeholder" }, { key: 'exist', name: "Existing Stakeholder" }]}
						value={selectedOption}
						onChangeRadio={handleRadioChange}
						className="radio-group-class"
					/>
				</div>
				{
					selectedOption === 'new' && (
						<CreateNewStakeHolder
							inlineReader={true}
							custmerDetails={props?.customerDetails}
							branch={props?.branchUsers}
							branchDetails={props?.branchDetails}
							customerId={props?.customerId}
							visible={stakeVisible}
							position={'right'}
							customerTableData={props?.customerTableData}
							onHide={handleHide}
							relationshipOwner={props?.relationshipOwner}
							clientFieldsNew={props?.stakeholderData?.clientFieldsNew}
							commonFields={props?.stakeholderData?.commanFieldsNew}
							currency={props?.currency}
							havingBranch={true}
							branchIdFromLS={{ branch_key: 'main' }}
							clientSectionsNew={props?.stakeholderData?.clientSectionsNew}
							addStakeholder={(data, clientId) => addStakeholder(data, clientId)} />
					)
				}
				{
					selectedOption === 'exist' && (
						<>
							<div className="form-group row align-items-center mb-0 mt-10">
								<div className="col-md-4 pl-0">
									<label className="form-label text-left"> {_.find(props.stakeholderData?.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
								</div>
								<div className="col-md-1 pl-0">
									{
										props.customerTooltipSummary?.opportunity?.client.status == true &&
										<div>
											<Tooltip target=".custom-target-icon" />

											<i className="custom-target-icon pi pi-info-circle tooltip-font"
												data-pr-tooltip={props.customerTooltipSummary?.opportunity?.client.text}
												data-pr-position="right">
											</i>
										</div>
									}
								</div>
								<div className='col pr-0'>
									<Controller
										name="client_name"
										control={control}
										style={{ innerHeight: 10 }}
										render={({ field }) => {
											const stakeholderOptions = stakeHolderDetails.map((client) => ({
												value: client,
												label: client.client_name,
											}));
											return (
												<DropdownElement
													onChange={(e) => field.onChange(e.value)}
													id="client_name"
													options={(stakeholderOptions != undefined && stakeholderOptions.length > 0) ? stakeholderOptions : []}
													optionLabel="label"
													placeholder="-- Please select --"
													className="w-full"
													filter
													{...field}
													maxSelectedLabels={1}
													value={field.value}
												/>
											);
										}}
									/>
								</div>
							</div>
						</>
					)
				}
			</Dialog>
			<Dialog
				visible={isTeamModelOpen}
				breakpoints={{ "960px": "75vw", "641px": "90vw" }}
				header="Add"
				modal
				position="center"
				onHide={closeTeamDialog}
				footer={renderTeamFooter()}
				className='width-32'
				draggable={false}
			>
				<div className='new-field'>
					<RadioElement
						id="team_member"
						options={[{ key: 'new', name: "Add Team Member" }, { key: 'exist', name: "Existing Team Member" }]}
						value={selectedOption}
						onChangeRadio={handleRadioChange}
						className="radio-group-class"
					/>
				</div>
				{selectedOption === 'new' && (
					<CreateNewContacts
						inlineReader={true}
						visible={teamVisible}
						position={'right'}
						customerId={props?.customerId}
						clientName={props?.clientName}
						fieldDetail={props?.fieldDetails}
						onHide={handleTeamHide}
						addressDetails={props?.addressDetails}
						clientSectionsSummary={props.stakeholderData.clientSectionsSummary}
						commonFields={props.stakeholderData.commanFieldsNew}
						addressContactFields={props.stakeholderData.addressContactFields}
						addTeamMember={(data) => addNewMembers(data)}
					/>
				)}
				{selectedOption === 'exist' && (
					<>
						<div className="form-group row align-items-center mb-0 mt-10">
							<div className="col-md-5 pl-0">
								<label className="form-label text-left">Select Team Member:</label>
							</div>
							<div className='col pr-0'>
								<Controller
									name="team"
									control={control}
									style={{ innerHeight: 10 }}
									render={({ field }) => {
										const teamOptions = orgTeam.map((team) => ({
											value: team,
											label: team.full_name,
										}));
										return (
											<MultiSelectElement
												onChangeValue={(e) => field.onChange(e.value)}
												id="team"
												options={teamOptions}
												optionLabel="label"
												placeholder="-- Please Select Team Member --"
												className="w-full"
												{...field}
												maxSelectedLabels={1}
												value={field.value}
											/>
										);
									}}
								/>
							</div>
						</div>
					</>
				)}
			</Dialog>
			<Dialog id="videoModal" visible={showVideo}
				breakpoints={{
					'1200px': '80vw',    // Larger modal on bigger screens
					'1024px': '85vw',    // Slightly smaller for medium screens
					'769': '90vw',     // Responsive on tablets
					'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="portfolio_stakeholders" />
					</div>
				</div>
			</Dialog>
			<div className="cancel-footer mt-20">
				<div className='d-flex align-center justify-end pb-0'>
					<ButtonElement className="save-button" type="submit" label={`Generate ${props.stakeholderData.pipelineStakesubmodule} Report`} onClick={generateAdvisorReport} />
				</div>
			</div>
		</div>
	)
})

export default Stakeholders;